import React from "react";
const Preset3 = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("rect", { x: "8.5", y: "40.5", width: "95", height: "31", rx: "3.5", stroke: "#DFE5EB" }),
    /* @__PURE__ */ React.createElement("rect", { x: "12", y: "44", width: "24", height: "24", rx: "2", fill: "url(#paint0_linear_6001_4871)" }),
    /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "50", r: "4", fill: "white" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M15.0783 60.0939L12 63.2245V64C12 66.2091 13.7909 68 16 68H34C35.1046 68 36 67.1046 36 66V60.5714L32.6609 57.1755C31.4853 55.98 29.5581 55.98 28.3826 57.1755L22.4348 63.2245L19.3565 60.0939C18.181 58.8984 16.2538 58.8984 15.0783 60.0939Z",
        fill: "url(#paint1_linear_6001_4871)"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { x: "43", y: "55", width: "16", height: "8", rx: "2", fill: "#116DFF" }),
    /* @__PURE__ */ React.createElement("rect", { x: "43", y: "49", width: "28", height: "3", rx: "1.5", fill: "#868AA5" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M74 50.5C74 49.6716 74.6716 49 75.5 49C76.3284 49 77 49.6716 77 50.5C77 51.3284 76.3284 52 75.5 52C74.6716 52 74 51.3284 74 50.5Z",
        fill: "#000624",
        fillOpacity: "0.3"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M78 50.5C78 49.6716 78.6716 49 79.5 49H85.5C86.3284 49 87 49.6716 87 50.5C87 51.3284 86.3284 52 85.5 52H79.5C78.6716 52 78 51.3284 78 50.5Z",
        fill: "#000624",
        fillOpacity: "0.3"
      }
    ),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_6001_4871",
        x1: "24",
        y1: "44",
        x2: "24",
        y2: "68",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ), /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint1_linear_6001_4871",
        x1: "24",
        y1: "55",
        x2: "24",
        y2: "68",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ))
  );
};
export {
  Preset3
};
//# sourceMappingURL=Preset3.js.map
